import {toast} from 'react-toastify';

let initialState = {
	infos: [],
	one: [],
	create: [],
	update: [],
	delete: []
};

const getCoeurInfos = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_COEURS_RETURN':
			return Object.assign({}, state, {infos: action.payload});

		case 'GET_COEUR_RETURN':
			return Object.assign({}, state, {one: action.payload});

		case 'POST_COEUR_RETURN':
			let newStateAdd;
			if (action.payload.status === 201) {
				newStateAdd = {...state.infos, data: action.payload.data};
				const notifySuccess = () =>
					toast.success('Coup de coeur ajouté !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				newStateAdd = state.infos;
				if (action.payload.status === 400) {
					const notifyError = () =>
						toast.error('Erreur merci de nous le signaler !', {
							position: 'top-right',
							autoClose: 3000,
							hideProgressBar: false,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined
						});
					notifyError();
				}
			}
			return Object.assign({}, state, {
				create: action.payload,
				infos: newStateAdd
			});

		case 'PUT_COEUR_RETURN':
			let array = [];
			let newStateUpdate;
			if (action.payload.status === 202) {
				array = state.infos.data.map((item) => {
					return item.uuid === action.payload.data.uuid ? action.payload.data : item;
				});
				newStateUpdate = {...state.infos, data: array};
				const notifySuccess = () =>
					toast.success('Coup de coeur mis à jour !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				newStateUpdate = state.infos;
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {
				update: action.payload,
				infos: newStateUpdate,
				one: action.payload
			});

		case 'PUT_COEURSTATUT_RETURN':
			let arrayStatut = [];
			let newStateUpdateStatut;
			if (action.payload.status === 200) {
				arrayStatut = state.infos.data.map((item) => {
					return item.uuid === action.payload.data.uuid ? action.payload.data : item;
				});
				newStateUpdateStatut = {...state.infos, data: arrayStatut};
				const notifySuccess = () =>
					toast.success('Coup de coeur mis à jour !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				newStateUpdateStatut = state.infos;
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {
				update: action.payload,
				infos: newStateUpdateStatut
			});

		case 'DEL_COEUR_SAGAS':
			const banc = state.infos.data;
			const indexBanc = banc.findIndex((index) => index.uuid === action.payload);
			const newStateDelete = {...state.infos, data: banc.filter((item, i) => i !== indexBanc)};

			return Object.assign({}, state, {infos: newStateDelete});

		case 'DEL_COEUR_RETURN':
			if (action.payload.status === 202) {
				const notifySuccess = () =>
					toast.success('Coup de coeur supprimé !', {
						position: 'top-right',
						autoClose: 2000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifySuccess();
			} else {
				const notifyError = () =>
					toast.error('Erreur ! merci de le signaler...', {
						position: 'top-right',
						autoClose: 3000,
						hideProgressBar: false,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined
					});
				notifyError();
			}
			return Object.assign({}, state, {delete: action.payload});

		default:
			return state;
	}
};

export default getCoeurInfos;
